// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1F3T8","signatureBlock":"Footer_signatureBlock__XI0VF","signature":"Footer_signature__3DqBz"};